<script lang="ts">
  import WorkOrderPropertyTag from "../../../../../../../_shared/_modules/work-order-property-tag"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()
</script>

<WorkOrderPropertyTag tag={row.propertyTag} tooltipContent={row.propertyTooltip} />
